import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { CountriesCurrenciesService } from 'src/app/countries-currencies/countries-currencies.service';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';
import { debug, log } from 'console';
import { BehaviorSubject, firstValueFrom, Observable, of, Subject, throwError } from 'rxjs';
import { SiteService } from 'src/app/services/site.service';
// import { SiteService } from '.././../../new-sites-management/common/services';

import { JsonPipe } from '@angular/common';
import { MatDialog as MatDialog, MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from "../../../services/auth.service"
import { EmailTemplateService } from "../services/email-template.service"
import { IconsComponent } from '../../../site-menu/icons/icons.component';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { PricingQoutationService } from 'src/app/pricing-qoutation/common/pricing-qoutation.service';
import { icons } from 'src/app/shared-data/common-arrays';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';

declare const $: any;

@Component({
  selector: 'app-add-edit-email-template',
  templateUrl: './add-edit-email-template.component.html',
  styleUrls: ['./add-edit-email-template.component.css'],

})
export class AddEditEmailTemplateComponent implements OnInit {
  emailTemplate: any = {
    additionalInfo: {}
  };
  hideRow = true;
  id: any;
  safeUrl: any
  flatPagesSlugs: any[] = [];
  emailTypes: any[] = [];
  formNames: any[] = [];
  culturs: any;
  keys: any[] = [];
  icon: any[] = icons;
  icons: any[] = icons;
  iconTouched: boolean = false;
  tempMenu: any = {};
  modalRef: BsModalRef;
  modalIframRef: BsModalRef;

  searchText = "";
  Icon: any;
  destroyed = new Subject()
  HostNames: any[] = [];
  siteDetails: any;
  @ViewChild('iframe', { static: false, read: ElementRef }) iframe: ElementRef<HTMLIFrameElement>;
  @ViewChild('IframModal') IframModal!: TemplateRef<any>;
  dominOfIframe: any;
  showElement: boolean = true;
  ;



  previewMode: boolean;
  // @ViewChild('emailTemplateForm',{static:true}) emailTemplateFormRef:NgForm
  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private sontify: ToastrService, private countriesCurrenciesService: CountriesCurrenciesService,
    public siteService: SiteService,
    private _snackBar: MatSnackBar,
    private authService: AuthService,
    private emailTemplateService: EmailTemplateService,
    public dialog: MatDialog,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    public pricingQoutationService: PricingQoutationService, public cdr: ChangeDetectorRef) {
    this.cdr.markForCheck()


  }

  ngOnInit() {
    this.showElement = true

    var user = this.authService.getLoggedUser();
    this.id = this.activeRouter.snapshot.paramMap.get("id")
    this.culturs = [];
    this.getEmailTypes();

    //this.getFormNames()
    this.siteService.getUsedCulturs(+user.siteId).subscribe((res) => {

      this.culturs = res;

    })
    if (this.id) {
      this.GetEmailTemplateById(this.id);
    }

  }
  ngAfterViewInit() {
    // Listen for messages from iframe

  }



  // getFormNames() {
  //    //   this.httpClient.get(`/Forms/GetAllForms`).subscribe((res: any) => {
  //     this.formNames = res;
  //     //this.formNames= JSON.parse(JSON.stringify(this.formNames))
  //   });
  // }
  ifFormType() {
    // if transformed to ng-select add delete selected item if statement 
    this.keys = null;
    this.keysvalue = null;
    this.flatPagesSlugs = null;
    this.emailTemplate.additionalInfo.pageId = null;
    if (this.emailTemplate.emailTemplateTypeId == 2 || this.emailTemplate.emailTemplateTypeId == 5) {
      this.getAllPagesFlat();
    }

  }

  getAllPagesFlat() {

    let id = this.culturs.find(x => x.name == this.emailTemplate.cultureId).id;


    this.emailTemplateService.getAllPagesFlat(id)
      .subscribe((res) => {
        this.flatPagesSlugs = res;
      })


  }

  returnFormname(form) { return JSON.parse(form.formName) }
  getEmailTypes() {
    this.emailTemplateService.getEmailTypes().subscribe((res: any) => {
      this.emailTypes = res;
    });
  }
  GetEmailTemplateById(id) {

    id = decodeURIComponent(id)
    this.emailTemplateService.GetEmailTemplateById(id).subscribe((res: any) => {
      this.emailTemplate = res;


      if (res.additionalInfo) {
        this.emailTemplate.additionalInfo = JSON.parse(this.emailTemplate.additionalInfo);
        this.Icon = res.icon
        // this.icon=res.icon

      }
      else {
        this.emailTemplate.additionalInfo = {};
        this.Icon = res.icon
        // this.icon=res.icon

      }

      if (this.emailTemplate.emailTemplateTypeId == '2' ||this.emailTemplate.emailTemplateTypeId == '5') {
        this.getAllPagesFlat();
        this.getKeys();


      }
    });
  }


  public getFormName(pageId) {
    if (this.emailTemplate.additionalInfo && this.emailTemplate.additionalInfo.pageId)
      this.emailTemplateService.getFormName(this.emailTemplate).subscribe((res: any) => {
        this.formNames = res
      })
  }

  getKeys() {
    this.keys = null;
    this.keysvalue = null;
    if (this.emailTemplate.additionalInfo && this.emailTemplate.additionalInfo.pageId) {
      this.emailTemplateService.getKeys(this.emailTemplate).subscribe((res: any) => {
        this.formNames = res;
        this.keys = [];
        if (this.formNames.length) {
          this.flatForm();

        }
      })
    }

  }

  keysvalue;
  keysValue() {
    this.keysvalue = null;

    if (this.emailTemplate.additionalInfo && this.emailTemplate.additionalInfo.emailFormName) {

      if (this.keys && this.emailTemplate.additionalInfo && this.emailTemplate.additionalInfo.emailFormName)
        this.keysvalue = this.keys.filter(x => x.id == this.emailTemplate.additionalInfo.emailFormName)[0].key
    }
  }

  flatForm() {
    for (let item of this.formNames) {

      this.keys.push({ formName: item.formName, id: item.id, key: JSON.parse(item.key) })

    }
    this.keysValue();


  }

  save(emailTemplate: any) {
    if (emailTemplate.invalid) {
      Object.keys(emailTemplate.controls).forEach(feild => {
        emailTemplate.controls[feild].markAsTouched(true);
      });
      this.iconTouched = true
      return;
    }
    var emailBody = $('.summernote').summernote('code').trim();

    if (!emailBody || emailBody == '') {
      this.sontify.error("Please fill the email content.");
      return;

    }
    var body: any = {};
    var formObj: any = emailTemplate.controls;

    body.emailBody = emailBody;

    if (formObj.emailFormName) {
      if (!body.additionalInfo)
        body.additionalInfo = {};
      body.additionalInfo.emailFormName = formObj.emailFormName.value;
    }


    body.subject = formObj.subject.value;
    body.emailTemplateTypeId = formObj.emailTemplateTypeId.value;
    body.cultureId = formObj.cultureId.value;
    body.color = formObj.color.value;
    body.icon = formObj.icon.value;


    if (formObj.emailTemplateTypeId.value == '2') {
      if (formObj.pageId) {
        if (!body.additionalInfo)
          body.additionalInfo = {};
        body.additionalInfo.pageId = formObj.pageId.value
      }
    }

    if (body.additionalInfo) {
      body.additionalInfo = JSON.stringify(body.additionalInfo)
    }

    if (this.id) {
      body.id = this.id;
      this.emailTemplateService.editTemplate(body)
        .subscribe(() => {
          this.router.navigate(["/email-template"],
            { relativeTo: this.activeRouter })
          this.sontify.success('Email template updated successfully');

        }, (err) => {
          this.sontify.error(err.message);
        })
      // promise

    } else {
      this.emailTemplateService.addTemplate(body)
        .subscribe((res) => {
          this.router.navigate(["../"], { relativeTo: this.activeRouter })
          this.sontify.success('Email template added successfully');

        }, (err) => {
          this.sontify.error(err.message);

        });
    }
  };

  copyText(val: string, withArrows?: boolean) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    if (withArrows) {
      val = '${{' + val + '}}'
    }
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this._snackBar.open('Copied Successfully!', 'close', { duration: 1000 })
      ;
  }


  copyAllKeys(type?: string) {
    if (type) {
      this.copyText('${{ALL_KEYS}}')
    }
    else {
      var text = '';
      for (let key of this.keysvalue) {
        text += '${{' + key + '}}';
      }
      this.copyText(text);

    }
  }

  changeCulture() {
    if (this.emailTemplate.additionalInfo && this.emailTemplate.additionalInfo.pageId)
      this.emailTemplate.additionalInfo.pageId = null;
    this.keys = null;
    this.keysvalue = null;
    // this.emailTypes = null;
    this.flatPagesSlugs = null;

    this.ifFormType();
  }
  openModal(template: TemplateRef<any>) {
    this.pricingQoutationService.ShowSubNavSubject.next(true);
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });

  }
  deleteIcon() {
    this.Icon = null;
  }

  onBlurIcon() {
    this.iconTouched = true;
  }

  FilterIcons() {
    if (this.searchText !== "") {
      this.icons = this.icon.filter(element =>
        element.value.toUpperCase().includes(this.searchText.toUpperCase())
      );
    } else {
      this.icons = this.icon;
    }
    this.cdr.detectChanges(); // Manually trigger change detection
  }
  async setPreveiwLink() {
    this.HostNames = [];
    const page = this.flatPagesSlugs.find((ele) => { return ele.pageId === this.emailTemplate.additionalInfo?.pageId })
    if (!this.siteDetails) {

      this.siteDetails = await firstValueFrom(this.siteService.getSiteDetails(this.authService.siteId))
    }

    let id = this.culturs.find(x => x.name == this.emailTemplate.cultureId).id;

    const hostNameByCulure = this.siteDetails.hostNames.filter((ele: any) => { return ele.cultureId == id });
    for (let index = 0; index < hostNameByCulure.length; index++) {
      const h = hostNameByCulure[index];
      let prefix = "";
      if (h.prefix) {
        prefix = h.prefix + "/";
      }

      this.HostNames.push({
        HostName: h.hostName + (prefix ? "/" + prefix : ""),
        LogoId: h.logoId,
        dominOfIframe: "https://" + h.hostName,
        CultureCodeId: h.cultureCodeId,
        link: this.sanitizer.bypassSecurityTrustResourceUrl(
          "https://" + h.hostName + "/" + prefix + page.parentPageSlug
        ),
      });
    }


  }
  afterCloseIconDilaog(res) {
    this.pricingQoutationService.ShowSubNavSubject.next(true);
    this.Icon = res
    this.onBlurIcon()
  }
  goToPreview(host: any) {
    console.log('tes');
    if(!this.emailTemplate.additionalInfo?.pageId){
      
      return
    }
    this.dominOfIframe = host.dominOfIframe
    this.setupPostMessageListener()
    this.modalIframRef = this.modalService.show(this.IframModal,
      {
        class: 'modal-lg', // Optional: make it large

      }
    )
    this.safeUrl = host.link
  }
  preview(template) {
    this.previewMode = false;
    this.modalRef = this.modalService.show(template)
  }


  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  onIframeLoad(iframe) {
    console.log('Iframe loaded');
    // Instead of accessing DOM directly, send a message to the iframe
    this.emailTemplate.emailBody=''
    this.sendMessageToIframe(iframe);
  }

  // Send message to iframe
  sendMessageToIframe(iframe) {

    if (iframe && iframe.contentWindow) {
      // Send a message to the iframe
      iframe.contentWindow.postMessage({
        action: 'getDOMInfo',
        timestamp: Date.now()
      }, this.dominOfIframe); // Specify target origin
    }

  }

  // Setup listener for messages from iframe
  setupPostMessageListener() {
    window.addEventListener('message', (event) => {
      // Verify the origin for security
      if (event.origin.toLowerCase() === this.dominOfIframe.toLowerCase()) {
        if(event?.data?.domInfo?.bodyHTML){

          this.emailTemplate.emailBody = event?.data?.domInfo?.bodyHTML.replace(/src="(Resources\/[^"]+)"/g, ('src=' + this.dominOfIframe + '/$1'));
        }else{
          return
        }
        // this.emailTemplate.emailBody = this.fixHrefLinks(this.emailTemplate.emailBody,this.dominOfIframe) 
   

        console.log('Iframe loaded22',event?.data?.domInfo);
        if (this.emailTemplate.emailBody) {
        console.log('Iframe loaded22',this.emailTemplate.emailBody);

          this.reRenderElement()
          this.modalIframRef.hide()
        }

      }
    });
  }

  reRenderElement() {
    this.showElement = false;
    setTimeout(() => this.showElement = true, 100); // triggers DOM re-render
  }
  fixHrefLinks(htmlString: string, baseUrl: string ): string {
    let fixedHtml = htmlString;
  
    // Replace relative hrefs that start with "/"
    fixedHtml = fixedHtml.replace(/href="\/([^"]*)"/g, `href="${baseUrl}/$1"`);
  
    // Replace href="home" with full URL
    fixedHtml = fixedHtml.replace(/href="home"/g, `href="${baseUrl}/home"`);
  
    // Replace href="javascript:;" with base URL
    fixedHtml = fixedHtml.replace(/href="javascript:;"/g, `href="${baseUrl}"`);
  
    // Replace fragment hrefs (like #our-team) with full URL + fragment
    fixedHtml = fixedHtml.replace(/href="(#[^"]*)"/g, `href="${baseUrl}$1"`);
  
    // Replace any remaining relative hrefs that don't start with http, https, or #
    fixedHtml = fixedHtml.replace(/href="([^"]*?)"/g, (match, url) => {
      // Skip if already absolute URL or fragment
      if (url.startsWith('http') || url.startsWith('https') || url.startsWith('#') || url.startsWith('mailto:') || url.startsWith('tel:')) {
        return match;
      }
      // Add base URL to relative links
      return `href="${baseUrl}/${url.replace(/^\//, '')}"`;
    });
  
    return fixedHtml;
  }


}
